<template>
  <!-- 页脚组件 -->
  <div>
    <el-footer height="30px">
      <!-- 公有云 页脚 -->
      <template v-if="isCloud">
        <span class="footer-block" v-if="isHuaWei">
          <img src="@/icon/bottom_logo.png" alt="" v-if="colorSrc" />
          <img src="@/icon/ic_bottom_logo.png" alt="" v-else />
        </span>
        <!-- 华微域名显示华微版权信息 -->
        <span v-if="isHuaWei" @click="tolink">
          Copyright © 1997-{{ _year }} 华微软件版权所有 | 华微软件 粤ICP备07033676号
        </span>
        <!-- 非华微域名显示中性信息 -->
        <span v-else>Copyright © 1997-{{ _year }} 智能安全帽组设计制作维护</span>
        <span v-if="isHuaWei" @click="toVersion"> | {{ $t('versionInfo') }}</span>
        <span v-if="isHuaWei" @click="toHelp"> | {{ $t('help') }}</span>
      </template>
      <!-- 私有化 页脚 -->
      <template v-else>
        <img :src="CPMPANY_ICON" alt="" />
        <span @click="tolink">{{ SYS_WEBSITE }}</span>
      </template>
    </el-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // 底部logo 显示
      colorSrc: false,
    }
  },
  mounted() {
    // 监听颜色变化icon
    if (this.$store.state.theme === 'default') {
      this.colorSrc = false
    } else {
      this.colorSrc = true
    }
  },
  computed: {
    ...mapGetters(['isCloud']),
    // 获取当前年月
    _year: function() {
      let Now = new Date()
      return Now.getFullYear()
    },
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    // 判断系统是否与huawei相关
    isHuaWei: function() {
      return location.host.indexOf('huaweisoft.com') === -1 ? false : true
    },
    CPMPANY_ICON: function() {
      return localStorage.getItem('CPMPANY_ICON')
    },
    SYS_WEBSITE: function() {
      return localStorage.getItem('SYS_WEBSITE')
    },
  },
  watch: {
    getTheme(val) {
      if (val === 'default') {
        this.colorSrc = false
      } else {
        this.colorSrc = true
      }
    },
  },
  methods: {
    // 点击跳转相关网页地址
    tolink() {
      window.open('https://beian.miit.gov.cn/')
    },
    // 点击查看版本信息
    toVersion() {
      window.open('https://intranet.iot.huaweisoft.com:6965/help/upgrade/version.html')
    },
    // 跳转帮助网站
    toHelp() {
      window.open('https://intranet.iot.huaweisoft.com:6965/help/icpfo-platform/web.html')
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.el-footer
  font-size 12px
  text-align center
  height 30px!important;/*no*/
  line-height 30px;/*no*/
  background: var(--new-footer-bg);
  img
    vertical-align middle
    margin-right: 6px;
  span
    vertical-align middle
    cursor pointer
    color #B4BED1;
  .footer-block
    line-height 14px
.theme-dark
  .el-footer
    span
      color #007CFF;
</style>
